import { useState } from "react";
import styles from "./EditScreenTextPositionSelection.module.css";
const EditScreenTextPositionSelection = ({
  selectedPosition,
  setSelectedPosition,
  width = 264,
  height = 264,
}) => {
  let middleStyles = {};
  if (width !== 264 || height !== 264) {
    if (width < height) {
      // vertical
      middleStyles = {
        position: "absolute",
        left: 0,
        top: 0,
        width: "124px",
        height: "100%",
        borderTop: "1px solid #707070",
        transform: "translateX(-39%) translateY(35%) rotate(45deg)",
        zIndex: -2,
        cursor: "not-allowed",
        content: "",
        "&:before": {
          content: '""',
        },
      };
    }
  }
  return (
    <div className="main_div">
      <div
        style={{ width: width + "px", height: height + "px" }}
        className={styles.grid}
      >
        <div
          onClick={() => {
            setSelectedPosition(1);
          }}
          className={`${styles.grid_item} ${
            selectedPosition === 1 ? styles.selected : ""
          }`}
        >
          1
        </div>
        <div
          onClick={() => {
            setSelectedPosition(2);
          }}
          className={`${styles.grid_item} ${
            selectedPosition === 2 ? styles.selected : ""
          }`}
        >
          2
        </div>
        <div
          onClick={() => {
            setSelectedPosition(3);
          }}
          className={`${styles.grid_item}  ${styles.right_border} ${
            selectedPosition === 3 ? styles.selected : ""
          }`}
        >
          3
        </div>
        <div
          onClick={() => {
            setSelectedPosition(4);
          }}
          className={`${styles.grid_item} ${
            selectedPosition === 4 ? styles.selected : ""
          }`}
        >
          4
        </div>
        <div className={` ${styles.grid_item_2}`}>
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width:
                width === height ? "124px" : width > height ? "152px" : "153px",
              height: "100%",
              borderTop: "1px solid #707070",
              transform:
                width === height
                  ? "translateX(-39%) translateY(35%) rotate(45deg)"
                  : width > height
                  ? "translateX(-26%) translateY(39%) rotate(36deg)"
                  : "translateX(-53%) translateY(29%) rotate(54deg)",
              zIndex: -2,
              cursor: "not-allowed",
              content: "",
              "&:before": {
                content: '""',
              },
            }}
            className={`${styles.middle_item}`}
          ></div>
        </div>
        <div
          onClick={() => {
            setSelectedPosition(5);
          }}
          className={`${styles.grid_item} ${styles.right_border} ${
            selectedPosition === 5 ? styles.selected : ""
          }`}
        >
          5
        </div>
        <div
          onClick={() => {
            setSelectedPosition(6);
          }}
          className={`${styles.grid_item}  ${styles.bottom_border} ${
            selectedPosition === 6 ? styles.selected : ""
          }`}
        >
          6
        </div>
        <div
          onClick={() => {
            setSelectedPosition(7);
          }}
          className={`${styles.grid_item} ${styles.bottom_border} ${
            selectedPosition === 7 ? styles.selected : ""
          }`}
        >
          7
        </div>
        <div
          onClick={() => {
            setSelectedPosition(8);
          }}
          className={`${styles.grid_item}  ${styles.bottom_border}  ${
            styles.right_border
          } ${selectedPosition === 8 ? styles.selected : ""}`}
        >
          8
        </div>
      </div>
    </div>
  );
};
export default EditScreenTextPositionSelection;
